import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NemAdgangButton from '../Account/NemAdgangButton';
const DashboardDocumentActionButton = ({ isNemAdgangRequired, title, children, icon, className }) => (_jsxs("li", Object.assign({ className: 'px-3 lg:px-6 hover:bg-gray-100 pt-1 lg:pt-2' }, { children: [isNemAdgangRequired && (_jsx(NemAdgangButton, { text: title, target: window.location.href, classes: classnames('tailwind-reset cursor-pointer', className), icon: icon })), !isNemAdgangRequired && children] })));
DashboardDocumentActionButton.propTypes = {
    isNemAdgangRequired: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.object.isRequired,
    icon: PropTypes.string,
    className: PropTypes.string
};
export default DashboardDocumentActionButton;
